import { heroImages, stats } from "@/mocks/siteData";

const principles = [
  { icon: "ri-eye-line", title: "只做整理，不下断案", text: "我们汇总公开声明与可核验素材，把事实链路摊开，结论留给你判断。" },
  { icon: "ri-time-line", title: "节点标注性质", text: "每条进展都标注是「后续、反转、回应」还是仍在核实，不把猜测当结论写。" },
  { icon: "ri-live-line", title: "更新不断更", text: "事件未完就持续跟进，重要节点优先补充，绝不一锤定音就消失。" },
  { icon: "ri-user-heart-line", title: "尊重所有当事人", text: "措辞留有余地，不渲染对立，不放大人身攻击，吃瓜也要讲基本礼仪。" },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-4 py-16 md:px-6 md:py-24 lg:grid-cols-2">
        <div className="relative order-2 lg:order-1">
          <img
            src={heroImages.about}
            alt="52爆料把新闻折成纸飞机飞向远方的主题插画"
            className="h-[300px] w-full rounded-2xl object-cover object-top md:h-[420px]"
          />
          <div className="absolute -bottom-5 left-5 rounded-2xl border border-background-200 bg-background-50 px-5 py-4 shadow-lift">
            <p className="font-accent text-2xl leading-none text-primary-600">吃瓜要讲理</p>
            <p className="mt-1 text-xs text-foreground-500">这是我们做 52爆料 的初衷</p>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <div className="flex items-center gap-3">
            <span className="inline-flex h-px w-8 bg-primary-500" aria-hidden="true" />
            <span className="kicker text-[11px] font-bold uppercase text-primary-600">About Us</span>
          </div>
          <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[34px]">
            52爆料是什么？
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-foreground-600">
            52爆料是一个专注把「连续剧式公共事件」梳理清楚的后续站。当一条瓜越来越长、评论区吵成一片时，
            我们负责把时间线拉直、把各方回应归位、把每一次反转的来龙去脉讲明白——让追更的人不再迷路，
            也不被断章取义牵着走。
          </p>
          <p className="mt-3 text-[15px] leading-relaxed text-foreground-600">
            我们不生产爆料，只做透明的搬运与整理：只引用公开来源，节点必标出处与时间，存疑处明说存疑。
            追到真相落地那天，是我们最有成就感的时候。
          </p>

          <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {principles.map((p) => (
              <div key={p.title} className="flex items-start gap-3 rounded-xl border border-background-200 bg-background-100 p-4">
                <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className={`${p.icon} text-lg`} />
                </span>
                <div>
                  <h3 className="font-heading text-sm font-bold text-foreground-950">{p.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-background-200 bg-background-100">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-2 gap-6 px-4 py-10 md:grid-cols-4 md:px-6 md:py-14">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-heading text-3xl font-black text-primary-600 md:text-4xl">
                {s.num}
                <span className="text-accent-500">{s.unit}</span>
              </p>
              <p className="mt-2 text-xs font-medium text-foreground-600 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}